// Generated by ReScript, PLEASE EDIT WITH CARE


var seconds = 1000 * 60;

var minutes = seconds * 60;

var hours = minutes * 60;

var days = hours * 24;

var weeks = days * 7;

var months = days * 30;

var Intervals = {
  millis: 1000,
  seconds: seconds,
  minutes: minutes,
  hours: hours,
  days: days,
  weeks: weeks,
  months: months
};

function epochToJsEpoch(epoch) {
  return epoch * 1000;
}

function differenceToNow(time) {
  return Date.now() - time;
}

function pluralizedAgo(singular, n) {
  var plural = singular + "s";
  if (n === 1) {
    return "1 " + singular + " ago";
  } else {
    return String(n | 0) + " " + plural + " ago";
  }
}

function get_time_ago(time) {
  var time$1 = time * 1000;
  var diff = Date.now() - time$1;
  if (diff < minutes) {
    return "just now";
  }
  var match = diff < hours ? [
      diff / minutes,
      "minute"
    ] : (
      diff < days ? [
          diff / hours,
          "hour"
        ] : (
          diff < weeks ? [
              diff / days,
              "day"
            ] : (
              diff < months ? [
                  diff / weeks,
                  "week"
                ] : [
                  diff / months,
                  "month"
                ]
            )
        )
    );
  return pluralizedAgo(match[1], match[0]);
}

export {
  Intervals ,
  epochToJsEpoch ,
  differenceToNow ,
  pluralizedAgo ,
  get_time_ago ,
  
}
/* No side effect */
